module.exports = __webpack_public_path__ + "img/booking_icon_clickable.48e0015f.svg";